/**
 * Human Resources (WALLIYO-0131), in English. English is the source text:
 * every other language is a faithful translation of it.
 */
export const hrEn = {
  "hr.tabs.aria": "Human Resources",
  "hr.tab.directory": "Directory",
  "hr.tab.recruiting": "Recruiting",
  "hr.tab.employees": "Employees",
  "hr.tab.learning": "Learning",
  "hr.subTabs.aria": "Employees",
  "hr.sub.records": "Records",
  "hr.sub.joining": "Joining",
  "hr.sub.timeOff": "Everybody's time off",
  "hr.sub.performance": "Performance",
  "hr.sub.payroll": "Payroll",
  "hr.sub.reviews": "Reviews",
  "hr.sub.leaving": "Leaving",
  "hr.locked": "This tab is for Human Resources.",
  "hr.notBuilt": "Not built yet.",
  "hr.notBuiltHelp": "This tab is designed and waiting on its endpoint. Nothing is lost by leaving it.",
  "hr.loading": "Reading…",
  "hr.failed": "That could not be read.",
  "hr.retry": "Try again",

  // ── Joining ──
  "joining.invite": "Invite somebody",
  "joining.invited.title": "Invitations out",
  "joining.invited.help": "They have a UUID already, and cannot sign in until they set a password.",
  "joining.invited.none": "Nobody is waiting to arrive.",
  "joining.arrived.title": "Arrived recently",
  "joining.arrived.help": "Everybody who joined in the last 30 days.",
  "joining.arrived.none": "Nobody has joined in the last 30 days.",
  "joining.col.name": "Name",
  "joining.col.roles": "Role",
  "joining.col.sent": "Invited",
  "joining.col.waiting": "Waiting",
  "joining.col.joined": "Joined",
  "joining.today": "Today",
  "joining.waiting": "{days} days",
  "joining.stale": "Worth a nudge",

  // ── Directory ──
  "directory.title": "Directory",
  "directory.sub": "Anyone can look anyone up.",
  "directory.search": "Find anyone",
  "directory.searchHelp": "A name, or the number on their badge.",
  "directory.searchPlaceholder": "Name or UUID",
  "directory.go": "Search",
  "directory.clear": "Show everyone",
  "directory.loading": "Reading the directory…",
  "directory.failed": "The directory could not be read.",
  "directory.retry": "Try again",
  "directory.none": "Nobody here matches “{query}”.",
  "directory.empty": "Nobody is listed yet.",
  "directory.count": "{shown} of {total}",
  "directory.more": "More matched than are shown. Narrow the search.",
  "directory.colName": "Name",
  "directory.colRoles": "Role",
  "directory.colTeams": "Teams",
  "directory.colManager": "Manager",
  "directory.open": "Open",
  "directory.noRole": "No role yet",
  "directory.noTeam": "No team yet",
  "directory.noManager": "No manager",
  "directory.leads": "leads it",
  "directory.invited": "Invited",
  "directory.back": "Back to the directory",
  "directory.identity": "Who they are",
  "directory.uuid": "UUID",
  "directory.uuidHelp": "The number on their badge. It never changes.",
  "directory.email": "Email",
  "directory.managerOn": "{name}, {team}",
  "directory.teammates": "Everyone on their teams",
  "directory.whereTheySit": "Where they sit",
  "directory.emailThem": "Send an email",
  "directory.teammatesNone": "They are the only person on their teams.",
  "directory.personFailed": "This person could not be read.",
  "directory.viewOnly": "The directory shows org structure only. What somebody may do is on Employees.",

  // ── Leaving ──
  "leaving.who": "Who is leaving",
  "leaving.whoHelp": "Everybody who is still here, and anybody who has already gone.",
  "leaving.pick": "Choose somebody",
  "leaving.alreadyLeft": "already gone",
  "leaving.nobody": "Choose somebody to see what leaving would leave behind.",
  "leaving.gone": "{name} has already gone. These are the loose ends that were left.",
  "leaving.noReason": "No reason was given",
  "leaving.teams.title": "Teams they lead",
  "leaving.teams.help":
    "Nobody approves leave, reviews anybody or attests to access on a team with no lead — those are the same fact.",
  "leaving.teams.none": "They lead no team.",
  "leaving.teams.col.team": "Team",
  "leaving.teams.col.others": "Other people on it",
  "leaving.teams.col.after": "After they go",
  "leaving.team.others": "{count} others",
  "leaving.team.noLead": "Nobody would lead it",
  "leaving.team.covered": "Somebody else leads it",
  "leaving.team.handOver": "Hand it over",
  "leaving.grants.title": "Granted to them by name",
  "leaving.grants.help":
    "Revoking a role never touches these. A grant with no end date is how somebody who has left still holds a permission.",
  "leaving.grants.none": "Nothing was granted to them by name.",
  "leaving.grants.col.what": "What",
  "leaving.grants.col.why": "Why",
  "leaving.grants.col.ends": "Ends",
  "leaving.grant.forever": "Never ends",
  "leaving.grant.until": "Ends",
  "leaving.grants.revoke": "Revoke these",
  "leaving.last.title": "The last step",
  "leaving.last.help":
    "Deactivating ends their {sessions} open sessions and stops them signing in. Nothing they did is removed — the audit names them for good — and they stay listed on their teams, so nobody is quietly short a person.",
  "leaving.last.deactivate": "Deactivate",
  "leaving.last.seeThem": "See them in the directory",

  // ── Records ──
  "records.find": "Find",
  "records.findPlaceholder": "Name or email",
  "records.team": "Team",
  "records.role": "Role",
  "records.any": "Any",
  "records.dueReview": "{count} access due a review",
  "records.accessDueReview": "access due a review",
  "records.none": "Nobody matches that.",
  "records.neverSeen": "Never signed in",
  "records.col.person": "Person",
  "records.col.role": "Role",
  "records.col.teams": "Teams",
  "records.col.joined": "Joined",
  "records.col.lastSeen": "Last seen",

  // ── Time off ──
  "timeOff.ask": "Ask for time off",
  "timeOff.approve": "Approve",
  "timeOff.refuse": "Refuse",
  "timeOff.days": "{days} days",
  "timeOff.decidedBy": "Decided by {name}",
  "timeOff.col.who": "Who",
  "timeOff.col.kind": "Kind",
  "timeOff.col.when": "When",
  "timeOff.col.days": "Days",
  "timeOff.col.status": "Status",
  "timeOff.kind.annual": "Annual leave",
  "timeOff.kind.sick": "Sick leave",
  "timeOff.kind.unpaid": "Unpaid",
  "timeOff.kind.parental": "Parental",
  "timeOff.kind.other": "Other",
  "timeOff.status.pending": "Waiting",
  "timeOff.status.approved": "Approved",
  "timeOff.status.refused": "Refused",
  "timeOff.status.withdrawn": "Withdrawn",
  "timeOff.balance.title": "Your balance",
  "timeOff.balance.none": "Nobody has set your allowance yet. Human Resources does that on your employment record.",
  "timeOff.balance.allowance": "Allowance",
  "timeOff.balance.taken": "Taken",
  "timeOff.balance.pending": "Asked for",
  "timeOff.balance.pendingHelp": "Not taken, but not free either.",
  "timeOff.balance.left": "Left",
  "timeOff.toDecide.title": "Waiting on you",
  "timeOff.toDecide.help": "You lead their team, so this is yours to decide. Being in HR is not the same thing.",
  "timeOff.mine.title": "Your requests",
  "timeOff.mine.none": "You have not asked for any time off.",
  "timeOff.away.title": "Away today",
  "timeOff.away.none": "Nobody is away today.",
  "timeOff.everybody.title": "Everybody's",
  "timeOff.everybody.help": "You can see these because you are in HR. Deciding them is their team lead's.",
  "timeOff.form.title": "Ask for time off",
  "timeOff.form.kind": "Kind",
  "timeOff.form.from": "First day",
  "timeOff.form.to": "Last day",
  "timeOff.form.days": "Days",
  "timeOff.form.daysHelp": "How many working days this covers.",
  "timeOff.form.reason": "Why",
  "timeOff.form.submit": "Send the request",
  "timeOff.decide.title": "Decide this request",
  "timeOff.decide.approveNote": "Say why you are approving it",
  "timeOff.decide.refuseNote": "Say why you are refusing it",
  "timeOff.decide.submit": "Record the decision",
  "timeOff.done": "Asked for {days} days. Whoever leads your team decides it.",
  "timeOff.approvedDone": "{name}'s time off is approved.",
  "timeOff.refusedDone": "{name}'s request is refused.",

  // ── Reviews ──
  "reviews.grants.title": "Worth a look right now",
  "reviews.grants.help":
    "A grant with an end date takes itself away. These are the ones that do not, and the ones held by somebody who is no longer here.",
  "reviews.grants.none": "Nothing is held by name without an end date.",
  "reviews.leads.title": "Leads who owe their people a look",
  "reviews.leads.help": "Whoever leads their team is who we already know — nobody has to be told who reviews whom.",
  "reviews.leads.none": "Nobody's people hold anything granted by name.",
  "reviews.col.who": "Who",
  "reviews.col.what": "What",
  "reviews.col.why": "Why",
  "reviews.col.concern": "Concern",
  "reviews.col.lead": "Lead",
  "reviews.col.team": "Team",
  "reviews.col.people": "People",
  "reviews.col.neverEnding": "Never ending",
  "reviews.concern.holderLeft": "They have left",
  "reviews.concern.neverEnds": "Never ends",
  "reviews.concern.neverUsed": "Never used",
  "reviews.changedAt": "Last changed {when}",
  "reviews.open": "Open their permissions",

  // ── Payroll ──
  "payroll.month": "Month",
  "payroll.open": "Open a month",
  "payroll.close": "Close the month",
  "payroll.notOpen": "This month has not been opened yet.",
  "payroll.closedOn": "Closed {when} by {name}",
  "payroll.hold": "Hold",
  "payroll.release": "Release",
  "payroll.lines.title": "What each person is paid",
  "payroll.lines.help":
    "Drawn from the employment records as they stood when the month was opened. A later raise does not change what is here.",
  "payroll.col.person": "Person",
  "payroll.col.gross": "Gross",
  "payroll.col.contributions": "Contributions",
  "payroll.col.net": "Net",
  "payroll.col.status": "Status",
  "payroll.status.ready": "Ready",
  "payroll.status.held": "Held",
  "payroll.status.paid": "Paid",
  "payroll.total.people": "People",
  "payroll.total.gross": "Gross",
  "payroll.total.contributions": "Contributions",
  "payroll.total.net": "Net",
  "payroll.missing.title": "Nobody knows what these people earn",
  "payroll.missing.help":
    "Their employment record has no gross, so a run cannot pay them. Set it before the next month is opened.",
  "payroll.openForm.title": "Open a month",
  "payroll.openForm.month": "Month",
  "payroll.openForm.help":
    "Every employment record with a gross gets a line. Contributions start at nothing: what is withheld depends on where somebody is, which is not this screen's to guess.",
  "payroll.openForm.submit": "Open it",
  "payroll.holdForm.title": "Change this line",
  "payroll.holdForm.hold": "Hold it back",
  "payroll.holdForm.release": "Let it go",
  "payroll.closeForm.title": "Close the month",
  "payroll.closeForm.help": "Every ready line becomes paid. A held one stays held, which is what holding it was for.",
  "payroll.closeForm.submit": "Close it",
  "payroll.opened": "{month} is open, with {count} lines.",
  "payroll.held": "{name}'s line is held.",
  "payroll.released": "{name}'s line will be paid.",
  "payroll.closed": "The month is closed.",

  // ── Performance ──
  "performance.cycle": "Cycle",
  "performance.openCycle": "Open a cycle",
  "performance.noCycle": "No cycle has been opened yet.",
  "performance.runs": "Runs {from} to {to}",
  "performance.write": "Write it",
  "performance.keepWriting": "Keep writing",
  "performance.col.who": "Who",
  "performance.col.reviewer": "Reviewer",
  "performance.col.status": "Status",
  "performance.col.outcome": "How it went",
  "performance.status.notStarted": "Not started",
  "performance.status.inProgress": "Being written",
  "performance.status.submitted": "Submitted",
  "performance.status.signedOff": "Signed off",
  "performance.gap.noTeam": "On no team",
  "performance.gap.noLead": "Team has no lead",
  "performance.gap.leadsOwn": "Leads their own team",
  "performance.toWrite.title": "Waiting on you",
  "performance.toWrite.help": "You lead their team, so this is yours to write.",
  "performance.mine.title": "Your review",
  "performance.mine.none": "You have no review this cycle.",
  "performance.everybody.title": "Everybody's",
  "performance.everybody.help": "You can see these because you are in HR. Writing one is still the reviewer's.",
  "performance.everybody.gaps":
    "{count} of these have nobody to write them. That is about the org, not about this cycle.",
  "performance.form.title": "Open a cycle",
  "performance.form.name": "Name",
  "performance.form.opens": "First day",
  "performance.form.closes": "Last day",
  "performance.form.submit": "Open it",
  "performance.writeForm.title": "Write the review",
  "performance.writeForm.outcome": "How it went",
  "performance.writeForm.outcomeHelp": "A word you chose, not a score out of five.",
  "performance.writeForm.note": "What happened",
  "performance.writeForm.save": "Save it for later",
  "performance.writeForm.send": "Submit it",
  "performance.opened": "{name} is open, with {count} reviews.",
  "performance.saved": "Saved. Nobody sees it until you submit it.",
  "performance.sent": "Sent. {name} can see it now.",

  // ── Recruiting and Learning ──
  "recruiting.openJob": "Open a vacancy",
  "recruiting.editJob": "Edit",
  "recruiting.addCandidate": "Add somebody",
  "recruiting.move": "Move them on",
  "recruiting.none": "No vacancy has been opened yet.",
  "recruiting.noTeam": "No team",
  "recruiting.noCandidates": "Nobody has applied yet.",
  "recruiting.liveCandidates": "{count} in the running",
  "recruiting.col.candidate": "Candidate",
  "recruiting.col.reach": "How to reach them",
  "recruiting.col.stage": "Stage",
  "recruiting.col.applied": "Applied",
  "recruiting.stage.applied": "Applied",
  "recruiting.stage.screening": "Screening",
  "recruiting.stage.interview": "Interview",
  "recruiting.stage.offer": "Offer out",
  "recruiting.stage.hired": "Hired",
  "recruiting.stage.declined": "Turned down",
  "recruiting.stage.withdrawn": "Withdrew",
  "recruiting.status.open": "Open",
  "recruiting.status.onHold": "On hold",
  "recruiting.status.filled": "Filled",
  "recruiting.status.closed": "Closed",
  "recruiting.jobForm.title": "Open a vacancy",
  "recruiting.jobForm.name": "Title",
  "recruiting.jobForm.team": "Team",
  "recruiting.jobForm.noTeam": "No team yet",
  "recruiting.jobForm.description": "What the job is",
  "recruiting.jobForm.status": "Status",
  "recruiting.jobForm.submit": "Open it",
  "recruiting.candidateForm.title": "Add somebody",
  "recruiting.candidateForm.name": "Name",
  "recruiting.candidateForm.phone": "Phone",
  "recruiting.candidateForm.email": "Email",
  "recruiting.candidateForm.note": "Anything worth knowing",
  "recruiting.candidateForm.submit": "Add them",
  "recruiting.moveForm.title": "Move them on",
  "recruiting.moveForm.stage": "Stage",
  "recruiting.moveForm.hired":
    "Marking somebody hired records that they were hired. Inviting them is on Joining, where it already is.",
  "recruiting.moveForm.submit": "Move them",
  "recruiting.jobOpened": "{title} is open.",
  "recruiting.jobEdited": "{title} is updated.",
  "recruiting.candidateAdded": "{name} is on the list.",
  "recruiting.candidateMoved": "{name} is now at {stage}.",
  "learning.addCourse": "Add a course",
  "learning.enrol": "Enrol",
  "learning.continue": "Keep going",
  "learning.finish": "Finish it",
  "learning.alreadyEnrolled": "Enrolled",
  "learning.requiredBy": "Required by {permission} — finish it before the grant, not after.",
  "learning.requiredOfAll": "Required of everybody",
  "learning.anybody": "Open to anybody",
  "learning.minutes": "{minutes} min",
  "learning.enrolled": "{count} enrolled",
  "learning.hrOnly": "HR only",
  "learning.mine.title": "Required of you",
  "learning.mine.help": "A course attached to a permission has to be finished before the permission is granted.",
  "learning.mine.none": "Nothing is required of you right now.",
  "learning.catalogue.title": "Catalogue",
  "learning.catalogue.help":
    "Open to anybody. Enrolling needs nobody's permission — it is the grant behind the course that does.",
  "learning.byTeam.title": "Across the company",
  "learning.byTeam.help": "Who still owes the required courses. Chasing them is whoever leads the team.",
  "learning.col.course": "Course",
  "learning.col.status": "Status",
  "learning.col.progress": "Progress",
  "learning.col.team": "Team",
  "learning.col.people": "People",
  "learning.col.done": "Done",
  "learning.status.enrolled": "Enrolled",
  "learning.status.inProgress": "Going",
  "learning.status.done": "Finished",
  "learning.courseForm.title": "Add a course",
  "learning.courseForm.name": "Title",
  "learning.courseForm.audience": "Who it is for",
  "learning.courseForm.minutes": "How long it takes, in minutes",
  "learning.courseForm.required": "Required by a permission",
  "learning.courseForm.requiredHelp": "The setting id of the permission this course is a condition on.",
  "learning.courseForm.everybody": "Required of everybody",
  "learning.courseForm.submit": "Add it",
  "learning.courseAdded": "{title} is in the catalogue.",
  "learning.enrolledDone": "Enrolled in {title}.",
  "learning.finished": "{title} is finished.",

  // ── Alerts and refusals ──
  "alert.dismiss": "Dismiss",
  "error.reason.permission_not_held":
    "Your role opens this screen, but not this action. Ask somebody who can grant it.",
  "error.reason.not_found": "This no longer exists. Reload and try again.",
  "error.reason.no_reason": "Say why, in a few words.",
  "error.reason.name_taken": "That name is already taken.",
  "error.reason.team_closed": "This is closed. Reopen it before adding anybody.",
  "error.reason.staff_deactivated": "They have left, so they cannot be added.",
  "error.reason.lead_must_be_member": "Somebody can only lead a team they are on.",
  "error.reason.duplicate_change": "The same person appears twice. Send them once.",
  "error.reason.own_request": "You cannot decide your own time off.",
  "error.reason.not_their_lead": "Only whoever leads their team can decide this. Being in HR is not the same thing.",
  "error.reason.already_decided": "This has already been decided. Reload to see what was decided.",
  "error.reason.backwards": "The last day is before the first one.",
  "error.reason.too_long": "That is longer than one request can cover.",
  "error.reason.month_open": "That month is already open.",
  "error.reason.already_paid": "This line has been paid. A closed month is what was paid.",
  "error.reason.already_closed": "This month is already closed.",
  "error.reason.nobody_payable": "Nobody has a gross recorded on their employment record.",
  "error.reason.invalid_month": "Give the month as YYYY-MM.",
  "error.reason.own_review": "You cannot write your own review.",
  "error.reason.not_the_reviewer": "Somebody else was asked to write this one.",
  "error.reason.signed_off": "This review has been signed off.",
  "error.reason.no_outcome": "Say how it went before submitting it.",
  "error.reason.job_closed": "This vacancy is closed. Reopen it before adding anybody.",
  "error.reason.candidate_out": "They are no longer in the running. Add them again if they come back.",
  "error.reason.title_taken": "That title is already taken.",
  "error.reason.course_retired": "This course is no longer being run.",
  "error.reason.invalid_progress": "Progress is a whole percent, from 0 to 100.",

  // ── Roles: what a role covers ──
  "roles.covers.everything": "Everything",
  "roles.covers.features": "{count} features",
  "roles.covers.permissions": "{count} permissions",
  "roles.covers.critical": "{count} critical",
  "roles.covers.high": "{count} high",
  "roles.covers.seeAll": "See all {count}",
  "roles.covers.permissionsHeading": "Permissions",

  // ── Roles, redesigned ──
  "roles.band.critical": "roles can decide what anybody may do",
  "roles.band.people": "people hold one of them",
  "roles.band.total": "roles in all",
  "roles.band.unheld": "nobody holds",
  "roles.reach.critical": "Critical",
  "roles.reach.high": "High",
  "roles.reach.low": "Low",
  "roles.rail.people": "{count} people",
  "roles.rail.unheld": "nobody holds it",
  "roles.noDescription": "No description",
  "roles.figure.people": "People",
  "roles.figure.features": "Features",
  "roles.figure.permissions": "Permissions",
  "roles.figure.critical": "Critical",
  "roles.block.holders": "Who holds it",
  "roles.block.holdersHelp": "Giving somebody this role gives them everything below.",
  "roles.block.holdersNone": "Nobody holds this role.",
  "roles.block.give": "Give it to somebody",
  "roles.block.take": "Take it away",
  "roles.block.grants": "What it grants",
  "roles.block.grantsHelp": "Where it reaches, by area.",
  "roles.block.criticalWarning": "Whoever holds this role can decide what anybody else may do.",
  "roles.block.change": "Change what it grants",
  "roles.block.opens": "What it opens",
  "roles.block.opensHelp": "Computed from the features above, never stored — the menu asks the same function.",
  "roles.block.opensNone": "It opens no screen on its own.",
  "roles.block.compare": "Compared with",
  "roles.block.compareWith": "Compare with",
  "roles.compare.only": "{count} only here",
  "roles.compare.theirs": "{count} only there",
  "roles.compare.shared": "{count} shared",
  "roles.give.title": "Give this role to somebody",
  "roles.give.who": "Who",
  "roles.give.submit": "Give it to them",
  "roles.give.done": "{name} now holds {role}.",
  "roles.take.title": "Take this role away",
  "roles.take.body": "They keep every other role they hold.",
  "roles.take.submit": "Take it away",
  "roles.take.done": "{name} no longer holds {role}.",
  "roles.holdersUnknown": "Could not be read",
  "roles.compare.same": "They grant exactly the same features.",
  "roles.notice.critical": "{roles} of these can decide what anybody may do — {people} people hold one.",
  "roles.notice.criticalOnly": "{roles} of these can decide what anybody may do.",
  "roles.notice.unheld": "{count} nobody holds.",

  // ── Actions, by person ──
  "actions.find": "Find somebody",
  "actions.matches": "Who did you mean?",
  "actions.findPlaceholder": "Name or UUID",
  "actions.nobody": "Search for somebody to see what they may do.",
  "actions.noRoles": "No role",
  "actions.col.on": "On",
  "actions.col.source": "Source",
  "actions.col.reason": "Reason",
  "actions.mustAsk": "must ask above {limit}",
  "actions.clear": "Clear",
  "actions.until": "until {when}",
  "actions.onlyOverrides":
    "Only an override is set on this person, so it is the only one this screen can take away. Everything else comes from a role or from how the action ships — change those where they live.",
  "actions.blocked.permission": "They have the capability, not the permission this action needs.",
  "actions.locked.noFeature": "Open to everybody: there is no switch behind it.",
  "actions.view.catalogue": "The catalogue",
  "actions.view.person": "By person",
  "actions.notWiredYet": "Switching this on is not wired up yet. Use Feature Enablements and Permissions for now.",
  "actions.view.role": "By role",
  "actions.pickRole": "Role",

  // ── Switching an action ──
  "actions.switch.onTitle": "Switch this on",
  "actions.switch.offTitle": "Switch this off",
  "actions.switch.clearTitle": "Clear this",
  "actions.switch.submit": "Switch it",
  "actions.switch.writes": "This writes the feature behind it: {feature}.",
  "actions.switch.alsoMoves": "That feature also unlocks {count} other actions, which move with it: {actions}.",
  "actions.switch.permissionToo":
    "They will still need the permission this action is gated by. Grant that on Permissions.",
  "actions.switch.switchedOn": "{action} is on for {who}.",
  "actions.switch.switchedOff": "{action} is off for {who}.",
  "actions.switch.cleared": "{action} is back to what it inherits.",
  "actions.pending": "not saved yet",
  "actions.saved": "{count} switches saved.",
} as const;
